import { styled } from '@porsche-code/kado-styled-system/jsx';

const Wrapper = styled('div', {
  base: {
    backgroundColor: 'background.surface',
    paddingTop: 'xl',
    paddingBottom: 'xl',
  },
});

const StyledFooter = styled('footer', {
  base: {
    flexShrink: 0,
  },
});

export const Footer = ({ children }: { children: React.ReactNode }) => (
  <StyledFooter>
    <Wrapper>{children}</Wrapper>
  </StyledFooter>
);
